export const REDUX_SAVE_SCHOOL_USER_PROFILE = 'REDUX_SAVE_SCHOOL_USER_PROFILE'
